<template>
	<!--首页-->
	<div class="app">
		<!--头部-->
		<navHeader></navHeader>
		<!--标题-->
		<div class="header_b">
			<img class="img-fluid" style="width: 100%;" src="../../../static/images/about.jpg" />
			<!--小导航-->
			<div class="nav_x">
				<span><img  src="../../../static/images/add.png"/></span>
				<span><a href="/">首页 </a></span>
				<span>/ 关于我们</span>
			</div>
		</div>
		<div class="comtit">
			<span>关于我们</span>
			<span>ABOUT US</span>
		</div>
		<!---->
		<div class="aboutVideo">
			<div class="container">
				<div class="row">
					<div class="col">
						<div class="img">
							<img class="img-fluid" style="width: 100%;" src="../../../static/images/aboutVideo.png" />
							<div class="tit">佛山市金利高陶瓷有限公司成立于2008年，公司位于广东省佛山市，隶属于新璟盛集团。新璟盛集团是新明珠集产业链品牌，注册资金5亿元人民币，员工上万名。集团拥有多个现代化生产基地及7万多平方米的一站式提货仓，是世界具影响力的的建陶航母。</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!--cate-->
		<div class="cate">
			<div class="container">
				<!--类目-->
				<div class="row">
					<div class="col" v-for="(item,index) in cateData">
						<div class="cate_li" :class="curr==index?'cate_li_on':''" @click="cateTab(index)">{{item.name}}</div>
					</div>
				</div>
			</div>
		</div>
		<!--data-->
		<div class="list">
			<div class="container" style="margin-top: 10px;margin-bottom: 10px;">
				<!--品牌简介-->
				<aboutList1 v-show="curr==0"></aboutList1>
				<!--品牌文化-->
				<aboutList2 v-show="curr==1"></aboutList2>
				<!--品牌荣誉-->
				<swiperTer :ban="ban" v-if="curr==2"></swiperTer>
			</div>
		</div>
		<!--发展历程-->
		<div class="dev">
			<div class="comtit">
				<span>发展历程</span>
				<span>DEVELLOPMENT HISTORY</span>
			</div>
			<devellopmebt></devellopmebt>
		</div>

		<!--联系我们-->
		<div class="callus">
			<div class="container">
				<div class="bg">
					<div class="li">
						<p class="tit">联系我们</p>
						<p class="tit">公司全称：佛山市金利高陶瓷有限公司</p>
						<p class="tit">营销中心地址：广东省佛山市禅城区南庄镇陶博大道15号金利高品牌</p>
						<p class="tit">成功热线：0757-8992 5781</p>
						<p class="tit">官方网址：http://www.goldceramics.cn</p>
					</div>
				</div>
			</div>
		</div>
		<!--底部-->
		<comFooter></comFooter>
	</div>
</template>
<script>
	import navHeader from '@/components/navHeader/index.vue'
	import comFooter from '@/components/comFooter/index.vue'
	import aboutList1 from '@/components/aboutList1/index.vue'
	import aboutList2 from '@/components/aboutList2/index.vue'
	import swiperTer from '@/components/swiperTer/index.vue'
	import devellopmebt from '@/components/devellopmebt/index.vue'
	export default {
		components: {
			navHeader,
			comFooter,
			aboutList1,
			aboutList2,
			swiperTer,
			devellopmebt
		},
		data() {
			return {
				curr: 0,
				cateData: [{
						name: '品牌简介'
					},
					{
						name: '品牌文化'
					},
					{
						name: '品牌荣誉'
					},
				],
				ban:[
				  {img:"http://www.goldceramics.cn/kps01/M00/7F/5B/wKiAiVwQv2eXaVSSAACgwILiFrw759.jpg",tit:"最佳产品奖"},
				  {img:"http://www.goldceramics.cn/kps01/M00/7F/5B/wKiAiVwQv0_k0rB5AAFhXyqpFzc867.jpg",tit:"工程建设推荐品牌"},
				  {img:"http://www.goldceramics.cn/kps01/M00/7F/5B/wKiAiVwQv2eXaVSSAACgwILiFrw759.jpg",tit:"最佳产品奖"},
				  {img:"http://www.goldceramics.cn/kps01/M00/7F/5B/wKiAiVwQv0_k0rB5AAFhXyqpFzc867.jpg",tit:"工程建设推荐品牌"},
				]

			}
		},
		created() {

		},
		mounted() { 
			let that = this
            that.curr = this.$route.query.curr
			if(that.curr==undefined){
				that.curr=0
			}
		},
		methods: {
			cateTab(index) {
				this.curr = index
			},
		},
	}
</script>
<style scoped lang="less">
	@w: 19.2vw;
	.aboutVideo {
		margin-bottom: 30px;
		.img {
			position: relative;
			.tit {
				color: #FFFFFF;
				font-size: 24/@w;
				background: rgba(0, 0, 0, .5);
				position: absolute;
				left: 0;
				bottom: 0;
				padding: 26/@w 100/@w;
				box-sizing: border-box;
				text-align: center;
			}
		}
	}
	
	.cate {
		.cate_li {
			border: 4/@w solid #D8D8D8;
			text-align: center;
			padding: 20/@w 0;
			color: #8A8A8A;
			font-size: 18/@w;
			cursor: pointer;
		}
		.cate_li_on {
			color: #A38061;
			font-weight: bold;
			border: 4/@w solid #A38061;
			background: rgba(209, 184, 162, 0.2);
		}
	}
	
	.callus {
		margin-top: 30px;
		.bg {
			background: url("../../../static/images/callus.png") ;
					padding: 60/@w 150/@w;
					 box-sizing: border-box;
			
			.li{
				text-align: center;
	            background: rgba(255,255,255,.7);
		        padding: 60/@w;
		        box-sizing: border-box;
		        border-radius: 10px;
				p {
				display: block;
				font-weight: bold;
				font-size: 16/@w;
				color:#616161;
				&:nth-last-child(1){
					margin-bottom: 0;
				}
				&:nth-child(1){
					color: #FF9300;
					font-size: 18/@w;
				}
		     	}
			}
			
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/about/index.vue